import type { useConfluenceAnalyticsEvents } from '@confluence/analytics/entry-points/useConfluenceAnalyticsEvents.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';

import type { AtAGlanceRequestCallbacks } from './atAGlanceTypes.ts';
import {
	getAtAGlanceAbortedEvent,
	getAtAGlanceFailedEvent,
	getAtAGlanceSucceededEvent,
} from './atAGlanceAnalytics.ts';

export const createAtAGlanceRequestReporter = (
	createEvent: ReturnType<typeof useConfluenceAnalyticsEvents>['createEvent'],
	{
		incomingLinkCount,
		outgoingLinkCount,
	}: { incomingLinkCount: number; outgoingLinkCount: number },
): Pick<AtAGlanceRequestCallbacks, 'onSuccess' | 'onFailure' | 'onAborted'> => ({
	onSuccess: (parsed, attributes) => {
		createEvent(
			getAtAGlanceSucceededEvent({
				overviewCount: parsed.overview.length,
				summariesCount: parsed.summaries.length,
				incomingLinkCount,
				outgoingLinkCount,
				...attributes,
			}),
		).fire();
	},
	onFailure: (failure, attributes) => {
		getMonitoringClient().submitError(failure, { attribution: Attribution.INTEGRATIONS });
		createEvent(
			getAtAGlanceFailedEvent({ incomingLinkCount, outgoingLinkCount, ...attributes }),
		).fire();
	},
	onAborted: (attributes) => {
		createEvent(
			getAtAGlanceAbortedEvent({ incomingLinkCount, outgoingLinkCount, ...attributes }),
		).fire();
	},
});
